import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Styled from './styles';

export interface VerticalDividerProps extends React.ComponentPropsWithRef<'div'> {
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** VerticalDivider, all other props are passed to the root element. */
const VerticalDivider = React.forwardRef<HTMLElement, VerticalDividerProps>((props, ref) => getContext(({ theme }) => {
  const {
    theme: themeProps,
    ...otherProps
  } = props;
  const resolvedTheme = _merge({}, theme.DIVIDER, themeProps);
  return (
    <Styled.VerticalDivider ref={ref} $theme={resolvedTheme} {...otherProps} />
  );
}));

VerticalDivider.displayName = 'VerticalDivider';

VerticalDivider.defaultProps = {
  theme: {}
};

export default VerticalDivider;
